import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { NgModule } from '@angular/core';
import { MAT_CHIPS_DEFAULT_OPTIONS } from '@angular/material/chips';
import { EDITOR_SERVICE } from '@core/injection-tokens/editor.injection.token';
import { NOTES_SERVICE } from '@core/injection-tokens/notes.injection.token';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MojoEditorModule } from 'mojo-editor';
import { MojoFeatureExtensionsModule } from 'mojo-feature-extensions';
import { MojoIrpNotesModule } from 'mojo-irp-notes';
import { MojoPrivilegesModule } from 'mojo-privileges';
import { QuillModule } from 'ngx-quill';

import { MaterialModule } from '@material/material.module';
import { NotesKeywordSearchComponent } from '@modules/notes/components/notes-keyword-search/notes-keyword-search.component';
import { NotesFiltersEffects } from '@modules/notes/filters-store/notes-filters.effects';
import { notesFiltersReducer } from '@modules/notes/filters-store/notes-filters.reducers';
import { MentionNamePipe } from '@modules/notes/pipe/mention-name.pipe';
import { SharedModule } from '@shared/shared.module';

import { NotesComponentsModule } from './components';
import { NotesContainerComponent } from './containers';
import { NoteFactoryModule } from './note-factory/note-factory.module';
import { NotesConfig } from './notes.abstract.config';
import { notesConfig } from './notes.config';
import { NotesEffects, notesReducer } from './store';
import { NotesFiltersService } from '@modules/notes/filters-store/notes-filters.service';

const containers = [NotesContainerComponent, MentionNamePipe];

@NgModule({
  imports: [
    SharedModule,
    NotesComponentsModule,
    StoreModule.forFeature('notes', notesReducer),
    StoreModule.forFeature('notesFilters', notesFiltersReducer),
    EffectsModule.forFeature([NotesEffects, NotesFiltersEffects]),
    MojoPrivilegesModule,
    MojoFeatureExtensionsModule,
    MaterialModule,
    QuillModule,
    MojoIrpNotesModule.forRoot(NOTES_SERVICE),
    MojoEditorModule.forRoot(EDITOR_SERVICE),
  ],
  declarations: [...containers, NotesKeywordSearchComponent],
  exports: [...containers, NoteFactoryModule],
  providers: [
    NotesFiltersService,
    {
      provide: NotesConfig,
      useValue: notesConfig,
    },
    {
      provide: MAT_CHIPS_DEFAULT_OPTIONS,
      useValue: {
        separatorKeyCodes: [ENTER, COMMA],
      },
    },
  ],
})
export class NotesModule {}
